import { render, staticRenderFns } from "./settled.vue?vue&type=template&id=4b3de9f6&scoped=true"
import script from "./settled.vue?vue&type=script&lang=js"
export * from "./settled.vue?vue&type=script&lang=js"
import style0 from "./settled.vue?vue&type=style&index=0&id=4b3de9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3de9f6",
  null
  
)

export default component.exports